import { disableFullscreenIfEnabled } from '../../gameClient/webgl/fullscreenFixer';
import { PaymentObject } from '../../types/payments';
import { validateSync } from "class-validator";

type PayParams = {
    pmObject: PaymentObject
};

export class PayHandler {
    public handle(params: PayParams): void {
        const payment = Object.assign(new PaymentObject(), params.pmObject);
        const errors = validateSync(payment);

        if (errors.length > 0) {
            const messages = errors
                .map(err => Object.values(err.constraints || {}))
                .flat();

            throw new Error(`Validation failed: ${JSON.stringify(messages)}`);
        }

        window.app.pay(params.pmObject);
        disableFullscreenIfEnabled();
    }
}
